'use client';
import { jsx } from 'react/jsx-runtime';
import { selectAnatomy } from '@ark-ui/anatomy';
import { forwardRef } from 'react';
import { ark } from '../factory.mjs';
import { useSelectContext } from './select-context.mjs';

const SelectValueText = forwardRef((props, ref) => {
  const { children, placeholder, ...rest } = props;
  const api = useSelectContext();
  return /* @__PURE__ */ jsx(ark.span, { ...selectAnatomy.build().valueText.attrs, ...rest, ref, children: children || api.valueAsString || placeholder });
});
SelectValueText.displayName = "SelectValueText";

export { SelectValueText };
